import React, { useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
  Box,
  Link,
  Snackbar,
  Alert,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { register } from "../services/ApiService";

export function Register() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [department, setDepartment] = useState("");
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "info" });

  const navigate = useNavigate();

  const handleRegister = async (event) => {
    event.preventDefault();

    try {
      const response = await register({
        name,
        email,
        password,
        department,
      });

      if (response.status === 200 || response.status === 201) {
        setSnackbar({ open: true, message: "User registered successfully!", severity: "success" });

        setTimeout(() => {
          navigate("/login");
        }, 1500);
      }
    } catch (err) {
      console.log("Registration error:", err.response);

      let message = "Registration failed. Please try again.";
      const data = err.response?.data;

      if (data && typeof data === "object") {
        message = Object.entries(data)
          .map(([field, msgs]) => `${field}: ${Array.isArray(msgs) ? msgs.join(", ") : msgs}`)
          .join(" | ");
      }

      setSnackbar({ open: true, message, severity: "error" });
    }
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(135deg, #1976d2, #1565c0)",
        padding: 2,
      }}
    >
      <Card
        sx={{
          width: "100%",
          maxWidth: 420,
          padding: 4,
          borderRadius: 3,
          backgroundColor: "#fff",
          boxShadow: "0 10px 24px rgba(0, 0, 0, 0.2)",
        }}
      >
        <CardContent>
          <Typography
            variant="h4"
            sx={{ textAlign: "center", fontWeight: 700, color: "#1565c0", mb: 1 }}
          >
            Sign Up
          </Typography>
          <Typography
            variant="body1"
            sx={{ textAlign: "center", color: "gray", mb: 3 }}
          >
            Create your account below
          </Typography>

          <form onSubmit={handleRegister}>
            <TextField
              fullWidth
              label="Full Name"
              variant="outlined"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              sx={{ marginBottom: 2 }}
            />
            <TextField
              fullWidth
              label="Email"
              variant="outlined"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              sx={{ marginBottom: 2 }}
            />
            <TextField
              fullWidth
              label="Password"
              variant="outlined"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              sx={{ marginBottom: 2 }}
            />
            <FormControl fullWidth sx={{ marginBottom: 2 }}>
            <InputLabel id="department-label">Department</InputLabel>
            <Select
              labelId="department-label"
              id="department-select"
              value={department}
              label="Department"
              onChange={(e) => setDepartment(e.target.value)}
              sx={{ marginBottom: 2 }}

            >
              <MenuItem value="Admin">Admin</MenuItem>
              <MenuItem value="Sales">Sales</MenuItem>
              <MenuItem value="Customer Support">Customer Support</MenuItem>
              <MenuItem value="Production">Production</MenuItem>
              <MenuItem value="Store">Store</MenuItem>
              <MenuItem value="Technical">Technical</MenuItem>
              <MenuItem value="Collection Recovery">Collection Recovery</MenuItem>
            </Select>
            </FormControl>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              size="large"
              sx={{
                backgroundColor: "#1565c0",
                fontWeight: "bold",
                mb: 2,
                "&:hover": {
                  backgroundColor: "#1976d2",
                },
              }}
            >
              Register
            </Button>
          </form>

          <Typography sx={{ textAlign: "center", mt: 1 }}>
            Already have an account?{" "}
            <Link
              component="button"
              onClick={() => navigate("/login")}
              sx={{ color: "#1565c0", fontWeight: "bold" }}
            >
              Login
            </Link>
          </Typography>
        </CardContent>
      </Card>

      {/* Snackbar */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}

